// Lib
import React from 'react';

import Feather from '../Feather';

// Styles
import { useStyles } from './ErrorStyles';

const Error = ({ message }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.error}>
      <Feather className={classes.icon} type="error" nativeColor />
      {message}
    </div>
  );
};

export default Error;
